import { Component, Input } from '@angular/core';
import { OccupationModel } from "@app/ps/models/occupation.model";
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  selector: 'tooltip-final-solution-state',
  templateUrl: './tooltip-final-solution-state.component.html',
})
export class TooltipFinalSolutionStateComponent {
  @Input() data!:  OccupationModel;
  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;
}
